<template>
  <div class="authen">
    <div class="login-container">
      <div
        class="login-content h-screen w-screen flex justify-center items-center"
      >
        <div class="login">
          <div class="title-wrap">
            <h3 class="title text-center font-extrabold text-4xl m-0">
              Yomokka
            </h3>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginMixin from "@/mixins/login.mixin";
import { validEmail } from "@/utils/validate";
const logo = require("@/assets/login/logo.png");

export default {
  mixins: [loginMixin],
  name: "Login",
  components: {},
  data: function() {
    const validateEmail = (rule, value, callback) => {
      if (!validEmail(value)) {
        callback(new Error("有効なメールアドレスを入力してください。"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error("パスワードは4つ文字以上を入力してください。"));
      } else {
        callback();
      }
    };
    return {
      loginRules: {
        email: [{ required: true, trigger: "blur", validator: validateEmail }],
        password: [
          { required: true, trigger: "blur", validator: validatePass },
        ],
      },
      loading: false,
      pwdType: "password",
      redirect: undefined,
      otherQuery: {},
      logo: logo,
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  width: 520px;
  max-width: 100%;
  padding: 0 35px;
  margin: 0 auto;
  overflow: hidden;
}

.authen {
  .el-input {
    display: inline-block;
    width: 85%;
  }
  .el-form-item__content {
    height: 40px;
    border: 1px solid #e0e5ed;
    box-sizing: border-box;
    border-radius: 2px;
    width: 100%;
  }
  .el-input__inner {
    border: none;
    height: 36px;
    background: #ffffff;
    font-size: 16px;
  }
  ::v-deep(.el-form-item) {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: #ffffff;
    border: 1px solid #e0e5ed;
    box-sizing: border-box;
    border-radius: 2px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #fdb92c;
    border-color: #fdb92c;
  }
  .el-checkbox__input.is-checked,
  .el-checkbox__input.is-focus .el-checkbox__inner {
    color: #fdb92c;
    border-color: #fdb92c;
  }
  .el-checkbox__label {
    color: #3d3d3d;
    font-weight: 400;
    font-size: 16px;
    padding-left: 5px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
  }
  .el-checkbox__inner:hover {
    border-color: #fdb92c;
  }
  .el-form-item {
    margin-bottom: unset;
    margin-top: 20px;
  }
  .svg-container {
    padding: 0 0 0 15px;
    color: gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    margin-top: -3px;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    color: #fdb92c;
    cursor: pointer;
    user-select: none;
  }
  .el-input {
    display: inline-block;
    width: 85%;
  }
  .el-button {
    padding: 8px !important;
  }
}
</style>
